module.exports = __webpack_public_path__ + "img/Tessellate55.785bff10.jpg";